import { Logo } from "./Logo";
import { useAuth } from "../lib/auth";

export function Header() {
  const { user, signOut } = useAuth();
  return (
    <header className="app-header">
      <div className="brand">
        <Logo size={28} />
        <span className="wordmark">Alibi · Marketing Agent</span>
      </div>
      <div className="account">
        <span className="email">{user?.email}</span>
        <button onClick={signOut} className="ghost">Sign out</button>
      </div>
    </header>
  );
}
